import React, { useEffect, useState } from "react";
import { SettingsService } from "../services/SettingsService";
import Toast from "../helpers/Toast";

interface DynamicComponentsContextProps {
  dynamicComponents: string;
}

const DynamicComponentsContext =
  React.createContext<DynamicComponentsContextProps>({
    dynamicComponents: "",
  });

interface DynamicComponentsProviderWrapperProps {
  children?: any;
}

export const DynamicComponentsProviderWrapper = (
  props: DynamicComponentsProviderWrapperProps
) => {
  const [dynamicComponents, setDynamicComponents] = useState<string>("");

  useEffect(() => {
    const service = new SettingsService();

    const getDynamicComponents = async () => {
      const response = await service.GetDynamicComponents();
      if (response.success === false || response.obj === null) {
        Toast.Show("error", response.message);
        return;
      }

      setDynamicComponents(response.obj.value);
    };

    getDynamicComponents();
  }, []);

  return (
    <DynamicComponentsContext.Provider
      value={{
        dynamicComponents: dynamicComponents,
      }}
    >
      {props.children}
    </DynamicComponentsContext.Provider>
  );
};

export const useDynamicComponentsContext = () =>
  React.useContext(DynamicComponentsContext);
